import {FC} from "react";
import {Text} from "../../ui-components/text.tsx";
import UserIcon from "../../assets/images/userFilled.svg";
import BanIcon from "../../assets/images/ban.svg";
import CopyIcon from "../../assets/images/copy.svg";
import TrashIcon from "../../assets/images/trashBlack.svg";
import SuggestIcon from "../../assets/images/iconP.svg";
import LikeIcon from "../../assets/images/like.svg";
import {BottomSheet} from "../../container/ModalSheet.tsx";
import {formatNumber, getEngagementRate} from "../../utils/Utils.ts";
import {ToastContainer} from "react-toastify";
import {LightButton} from "../buttons/LightButton.tsx";
import useChannelDetailsPage from "../../hooks/channel/useChannelDetailsModalPage.ts";
import {IsLoadingContainer} from "../../container/IsLoadingContainer.tsx";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

export const ChannelDetailsModal: FC<{
    isOpen: boolean;
    onClose: () => void;
    type: 'add' | 'remove',
    addToFavorite?: boolean
}> = ({
          isOpen,
          onClose,
          addToFavorite,
      }) => {
    const {
        isLoading,
        channelData,
        selectedCategories,
        blackListHandler,
        favouritesHandler,
        copyTelegramLink, conditionForAddingSinglePublication
    } = useChannelDetailsPage();

    const {t} = useTranslation();
    const navigate = useNavigate()

    const navigateToratePubliction = () => {
        if(channelData) {
            localStorage.setItem('selectedChannels', JSON.stringify([channelData]));
            navigate('/create_publication_2');
            onClose()
        }
    }
    const engagementRate = channelData ? getEngagementRate(channelData.average_views, channelData.subscribers_count) : 0
    return (
        <BottomSheet isOpen={isOpen} onClose={onClose}>
            <div className="w-full px-4 flex flex-col items-center relative overflow-hidden">
                <ToastContainer className={'ToastContainer'} containerId={'publication_details_id'}
                                style={{top: "23px"}}/>
                <div className="w-10 h-0.5 bg-[var(--color-line)] my-2"></div>
                <IsLoadingContainer isLoading={isLoading}>
                    {
                        channelData
                            ? <>
                                <div
                                    className="w-full bg-white rounded-lg border border-[var(--btn-border-custom)] px-4 py-3 mt-4">
                                    <div className="flex items-center gap-1">
                                        <div className="rounded-md">
                                            <img src={channelData.profile_image_url}
                                                 className="object-fill max-w-10 max-h-10 rounded-md"
                                                 alt="l"/>
                                        </div>
                                        <div className="flex flex-col ml-3">
                                            <Text
                                                className="!text-[16px] font-semibold !text-black">{channelData?.telegram_channel_name}</Text>
                                            <div className="flex gap-1">
                                                <UserIcon/>
                                                <span
                                                    className="text-xs text-[var(--color-secondary)]">{formatNumber(channelData?.subscribers_count)}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-4.5 mt-4.5">
                                        <div className="flex flex-col gap-1 pb-2.5 relative">
                                            <Text className="!text-sm text-[var(--color-secondary)]">
                                                {t('modals.channelDetails.averageViews')}
                                            </Text>
                                            <span
                                                className="!text-sm font-medium text-[var(--text-color-dark)]">{channelData.average_views}</span>
                                            <div
                                                className="absolute bottom-0 left-0 w-1/3 h-[1px] bg-[var(--default-page-color)]"></div>
                                        </div>
                                        <div className="flex flex-col gap-1 pb-2.5 relative">
                                            <Text className="!text-sm text-[var(--color-secondary)]">
                                                {t('modals.channelDetails.engagementRate')}
                                            </Text>
                                            <span
                                                className="!text-sm font-medium text-[var(--text-color-dark)]">{engagementRate} %</span>
                                            <div
                                                className="absolute bottom-0 left-0 w-1/3 h-[1px] bg-[var(--default-page-color)]"></div>
                                        </div>
                                        <div className="flex flex-col gap-1 pb-2.5 relative">
                                            <Text className="!text-sm text-[var(--color-secondary)]">
                                                {t('modals.channelDetails.categories')}
                                            </Text>
                                            <span
                                                className="!text-sm font-medium text-[var(--text-color-dark)]">{selectedCategories}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full my-4 pl-[18px] pr-4">
                                    <div className="w-full flex gap-4 items-center py-[18px] cursor-pointer"
                                         onClick={blackListHandler}>
                                        {!channelData.blacklisted ? <BanIcon/> : <TrashIcon/>}
                                        <Text className="!tex-sm !text-black">
                                            {!channelData.blacklisted
                                                ? t('modals.actions.addToBlacklist')
                                                : t('modals.actions.removeFromBlacklist')
                                            }
                                        </Text>
                                    </div>
                                    {
                                        addToFavorite &&
                                        <>
                                            <div className="w-full flex gap-4 items-center py-[18px] cursor-pointer"
                                                 onClick={favouritesHandler}>
                                                <LikeIcon/>
                                                <Text className="!tex-sm !text-black">
                                                    {!channelData.favourite
                                                        ? t('modals.actions.addToFavourites')
                                                        : t('modals.actions.removeToFavourites')
                                                    }
                                                </Text>
                                            </div>
                                            {
                                                conditionForAddingSinglePublication ?
                                                    <div
                                                        className="w-full flex gap-4 items-center py-[18px] cursor-pointer">
                                                        <SuggestIcon/>
                                                        <Text className="!tex-sm !text-black" onClick={navigateToratePubliction}>
                                                            {t('modals.actions.suggestSinglePublication')}
                                                        </Text>
                                                    </div>
                                                    : ''
                                            }
                                        </>
                                    }
                                    <div className="w-full flex gap-4 items-center py-[18px] cursor-pointer">
                                        <CopyIcon/>
                                        <Text className="!tex-sm !text-black"
                                              onClick={copyTelegramLink}>
                                            {t('modals.actions.copyChannelLink')}</Text>
                                    </div>
                                </div>
                                <LightButton title={t('common.buttons.cancel')} onClick={onClose}/>
                            </>
                            : ''
                    }
                </IsLoadingContainer>
            </div>
        </BottomSheet>
    );
};
